module.exports = __webpack_public_path__ + "img/icon-next-red.8b4f7bc5.svg";